export default __webpack_public_path__ + "static/media/Issues_Mobile.e2e4d1e0.svg";